import React, { useCallback, useState } from "react";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ActivitiesSection } from "./components/ActivitiesSection";
import { MenuSection } from "./components/MenuSection";
import { OutletsSection } from "./components/OutletsSection";
import { AboutSection } from "./components/AboutSection";
import { Footer } from "./components/Footer";
import { BookingModal } from "./components/BookingModal/BookingModal";
import type { BookingPrefill } from "./types/cafe";
export function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [prefill, setPrefill] = useState<BookingPrefill>({
    type: "activity"
  });
  const openBooking = useCallback((next?: BookingPrefill) => {
    setPrefill(next ?? {
      type: "activity"
    });
    setBookingOpen(true);
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="28sl0cofgp6ar">
      <Navbar onBook={() => openBooking()} data-id="element-1" data-mp="23ujkecdc1n3i" />
      <main data-id="element-2" data-mp="23ti67z10skhk">
        <Hero onBook={() => openBooking({
        type: "activity"
      })} data-id="element-3" data-mp="3ik7g4ghnibqn" />
        <ActivitiesSection onJoin={activityId => openBooking({
        type: "activity",
        activityId
      })} data-id="element-4" data-mp="3ijpet5g4t7bv" />
        <MenuSection data-id="element-5" data-mp="3mjpyp5m02aqb" />
        <OutletsSection onReserve={outletId => openBooking({
        type: "table",
        outletId
      })} data-id="element-6" data-mp="3rc9e8848zfxr" />
        <AboutSection data-id="element-7" data-mp="3relvsk63foaa" />
      </main>
      <Footer data-id="element-8" data-mp="680tswt8a8y" />
      <BookingModal open={bookingOpen} prefill={prefill} onClose={() => setBookingOpen(false)} data-id="element-9" data-mp="4n4pyuukj8z" />
    </div>;
}